module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1215.3a868c5a.png";